<template>
  <div class="container">
    <div class="row vertical-center">
      <div class="col-12 center">
        <h1>
          Wähle deine Sprache
          <br />Choisis ta langue
          <br />Seleziona la tua lingua
          <br />Select your language
        </h1>
        <div v-if="isMobile">
          <div class="row pushup">
            <div class="col-3">
              <img src="../assets/de.png" class="circle" alt="de" @click="next('de')" />
            </div>
            <div class="col-3">
              <img src="../assets/fr.png" class="circle" alt="fr" @click="next('fr')" />
            </div>
            <div class="col-3">
              <img src="../assets/it.png" class="circle" alt="it" @click="next('it')" />
            </div>
            <div class="col-3">
              <img src="../assets/en.png" class="circle" alt="en" @click="next('en')" />
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row pushup">
            <div class="col-2"></div>
            <div class="col-2">
              <img src="../assets/de.png" class="circle" alt="de" @click="next('de')" />
            </div>
            <div class="col-2">
              <img src="../assets/fr.png" class="circle" alt="fr" @click="next('fr')" />
            </div>
            <div class="col-2">
              <img src="../assets/it.png" class="circle" alt="it" @click="next('it')" />
            </div>
            <div class="col-2">
              <img src="../assets/en.png" class="circle" alt="en" @click="next('en')" />
            </div>
            <div class="col-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Language",
  data() {
    return {
      isMobile: window.innerWidth < 770,
    }
  },
  created() {
    window.addEventListener("resize", this.resizeHandler)
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler)
  },
  methods: {
    next(lang) {
      this.$i18n.locale = lang
      this.$router.push("/start")
    },
    resizeHandler() {
      this.isMobile = window.innerWidth < 770
    },
  },
}
</script>
<style scoped>
.center {
  text-align: center;
}

.pushup {
  margin-top: 10%;
}

h1 {
  font-size: 200% !important;
}

.circle {
  height: auto;
  width: 100%;
}

.circle:hover {
  /*-webkit-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);
  box-shadow: 5px 40px -10px rgba(0, 0, 0, 0.57);*/
  transition: all 0.4s ease 0s;
  transform: translate(-1px, -1px);
  cursor: pointer;
}

.circle:active {
  /*-webkit-box-shadow: 0px 2px 20px -10px rgba(0, 0, 0, 0.57);
  box-shadow: 2px 20px -10px rgba(0, 0, 0, 0.57);*/
  transition: all 0.4s ease 0s;
  transform: translate(1px, 1px);
}

.btn {
  border-radius: 50% !important;
  height: 100px !important;
  width: 100px !important;
  font-size: 0px !important;
}

.btn-primary {
  border-color: white !important;
  background-color: white !important;
  max-width: 100px;
  max-height: 100px;
  background-image: url("../assets/web_button.png");
  background-repeat: no-repeat;
  background-size: cover;
}

@media screen and (max-width: 770px) and (orientation: landscape) {
  h1 {
    font-size: 3.3vw !important;
  }
  .pushup {
    margin-top: 2%;
  }
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
@media screen and (max-width: 770px) and (orientation: portrait) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
</style>